import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=b5478004&scoped=true"
import script from "./StepIndicator.vue?vue&type=script&lang=js"
export * from "./StepIndicator.vue?vue&type=script&lang=js"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=b5478004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5478004",
  null
  
)

export default component.exports